import { Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';

import { ApInlineSvgDirective } from './inline-svg.directive';

@Injectable({
    providedIn: 'root'
})
export class ApInlineSvgService {
    private readonly renderer: Renderer2;

    constructor() {
        const rendererFactory = inject(RendererFactory2);

        this.renderer = rendererFactory.createRenderer(null, null);
    }

    public insertElement(
        directive: ApInlineSvgDirective,
        parentElement: HTMLElement,
        content: HTMLElement | SVGElement,
        replaceContents: boolean,
        prepend: boolean
    ) {
        if (replaceContents && !prepend) {
            const parentNode = directive._prevSVG && directive._prevSVG.parentNode;
            if (parentNode) {
                this.renderer.removeChild(parentNode, directive._prevSVG);
            }

            parentElement.innerHTML = '';
        }

        if (prepend) {
            this.renderer.insertBefore(parentElement, content, parentElement.firstChild);
        } else {
            this.renderer.appendChild(parentElement, content);
        }

        if (content.nodeName === 'svg') {
            directive._prevSVG = content as SVGElement;
        }
    }
}
